// extracted by mini-css-extract-plugin
module.exports = {"container":"DietsPageInfoWrapper_container__2WrqJ","wrapper":"DietsPageInfoWrapper_wrapper__1ePZu"};